module.exports = __webpack_public_path__ + "img/sharp-example12.7ba2f46f.jpg";